import { render, staticRenderFns } from "./label.vue?vue&type=template&id=4b43b260"
import script from "./label.vue?vue&type=script&lang=js"
export * from "./label.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b43b260')) {
      api.createRecord('4b43b260', component.options)
    } else {
      api.reload('4b43b260', component.options)
    }
    module.hot.accept("./label.vue?vue&type=template&id=4b43b260", function () {
      api.rerender('4b43b260', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/filter/v1/label.vue"
export default component.exports